// mds-dojo — dijit/a11yclick — FAITHFUL port of references/dijit/a11yclick.js.
// Synthetic press/release/click that also fire on Space/Enter keyup for nodes marked
// with dojoClick (keyboard-accessible click). Default export is the `click` extension
// event (dojo back-compat) with .press/.release/.move attached.
// ADAPTATION: mds `dojo/on` does NOT treat a function `type` as an extension event, and
// mds `dojo/touch` exports extension events as functions (node,listener)=>handle — so
// `on(node, touch.press, cb)` becomes `touch.press(node, cb)`.
import keys from '../dojo/keys';
import mouse from '../dojo/mouse';
import on from '../dojo/on';
import touch from '../dojo/touch';

const isLeft = (evt: any) => (mouse as any).isLeft ? (mouse as any).isLeft(evt) : evt.button === 0;

function clickKey(e: any): boolean | undefined {
  if ((e.keyCode === keys.ENTER || e.keyCode === keys.SPACE) && !/input|button|textarea/i.test(e.target.nodeName)) {
    for (let node = e.target; node; node = node.parentNode) {
      if (node.dojoClick) { return true; }
    }
  }
  return undefined;
}

let lastKeyDownNode: any;

if (typeof document !== 'undefined') {
  on(document, 'keydown', function (e: any) {
    if (clickKey(e)) {
      lastKeyDownNode = e.target;
      e.preventDefault(); // prevent space-key viewport scroll
    } else {
      lastKeyDownNode = null;
    }
  });

  on(document, 'keyup', function (e: any) {
    if (clickKey(e) && e.target == lastKeyDownNode) {
      lastKeyDownNode = null;
      (on as any).emit(e.target, 'click', {
        cancelable: true,
        bubbles: true,
        ctrlKey: e.ctrlKey,
        shiftKey: e.shiftKey,
        metaKey: e.metaKey,
        altKey: e.altKey,
        _origType: e.type,
      });
    }
  });
}

const click: any = function (node: any, listener: any) {
  // Mark node so keydown/keyup above emits click; also enables fast click.
  node.dojoClick = true;
  return on(node, 'click', listener);
};
click.click = click; // forward-compat with 2.0

click.press = function (node: any, listener: any) {
  const touchListener = touch.press(node, function (evt: any) {
    if (evt.type == 'mousedown' && !isLeft(evt)) { return; } // ignore right click
    listener(evt);
  });
  const keyListener = on(node, 'keydown', function (evt: any) {
    if (evt.keyCode === keys.ENTER || evt.keyCode === keys.SPACE) { listener(evt); }
  });
  return {
    remove: function () { touchListener.remove(); keyListener.remove(); },
  };
};

click.release = function (node: any, listener: any) {
  const touchListener = touch.release(node, function (evt: any) {
    if (evt.type == 'mouseup' && !isLeft(evt)) { return; } // ignore right click
    listener(evt);
  });
  const keyListener = on(node, 'keyup', function (evt: any) {
    if (evt.keyCode === keys.ENTER || evt.keyCode === keys.SPACE) { listener(evt); }
  });
  return {
    remove: function () { touchListener.remove(); keyListener.remove(); },
  };
};

click.move = touch.move;

export default click;
